<template>
    <div class="login-container">
        <img src="@/assets/imgs/icon49.png" class="logo" />
        <h5>艺术品科技超选平台</h5>
        <div class="content">
            <div class="form_container">
                <!-- 登录 -->
                <div v-if="!isRegister" class="login_form">
                    <div class="tabs">
                        <span :class="{ active: loginType == 0 }" @click="loginType = 0">账号登录</span>
                        <span :class="{ active: loginType == 1 }" @click="loginType = 1">短信登录</span>
                    </div>
                    <van-form @submitsubmit="onSubmit">
                        <van-cell-group inset>
                            <van-field v-model="loginForm.mobile" name="mobile" placeholder="手机号码"
                                :rules="[{ required: true, message: '请填写手机号码' }]" />
                            <van-field v-model="loginForm.password" type="password" name="password" placeholder="密码"
                                :rules="[{ required: true, message: '请填写密码' }]" v-if="loginType == 0" />
                            <van-row v-else>
                                <van-col span="16">
                                    <van-field v-model="loginForm.code" name="code" placeholder="请填写验证码"
                                        :rules="[{ required: true, message: '请填写验证码' }]" />
                                </van-col>
                                <van-col span="8">
                                    <button class="code_btn" @click.stop="sendCode(loginForm.mobile)" v-if="remainSecond <= 0">获取验证码</button>
                                    <button class="code_btn" v-else >{{ remainSecond }}秒后获取</button>
                                </van-col>
                            </van-row>
                        </van-cell-group>
                        <div>
                            <van-button round block type="primary" native-type="submit" @click="login">
                                登录
                            </van-button>
                        </div>
                    </van-form>
                    <!-- <p class="register" @click="isRegister = true;">立即注册</p> -->
                    <!-- <div class="line"></div> -->
                    <!-- <div class="third_login">
                        <span>第三方登录</span>
                        <div class="icons">
                            <van-icon :name="require('@/assets/imgs/icon51.png')" size="30rem" @click="loginThrid(10)"></van-icon>
                            <van-icon :name="require('@/assets/imgs/icon52.png')" size="30rem" @click="loginThrid(50)"></van-icon>
                        </div>
                        <p style="font-size: 12rem;">还没有账号？<span style="color: #FF3D1D;" @click="isRegister = true;">去注册</span></p>
                    </div> -->
                </div>
                <!-- 注册 -->
                <div class="register_form" v-else>
                    <div v-if="register_step == 1">
                        <h5>注册</h5>
                        <div class="type_select">
                            <div :class="{ active: registerForm.type == 1 }" @click="registerForm.type = 1;">个人入驻</div>
                            <div :class="{ active: registerForm.type == 2 }" @click="registerForm.type = 2;">企业入驻</div>
                        </div>
                        <van-button round block type="primary" @click="register_step = 2;">
                            注册
                        </van-button>
                    </div>
                    <div v-else>
                        <h5>{{ registerForm.type == 1 ? '个人注册' : '企业注册' }}</h5>
                        <div class="avatar"
                            :style="{ backgroundImage: registerForm.avatar ? 'url(' + registerForm.avatar + ')' : '' }">
                            <van-icon name="plus" size="30rem" v-if="!registerForm.avatar"></van-icon>
                            <input type="file" accept="image/*" @change="uploadCover" />
                        </div>
                        <van-form @submitsubmit="onSubmit">
                            <van-cell-group inset>
                                <van-field v-model="registerForm.name" name="name" placeholder="姓名"
                                    :rules="[{ required: true, message: '请填写用户名' }]" />
                                <van-field v-model="registerForm.enterTypeLabel" is-link readonly name="picker"
                                    placeholder="请选择企业类型" @click="showPicker = true"
                                    :rules="[{ required: true, message: '请选择企业类型' }]" v-if="registerForm.type == 2" />
                                <van-field v-model="registerForm.password" type="password" name="password"
                                    placeholder="密码" :rules="[{ required: true, message: '请填写密码' }]" />
                                <van-field v-model="registerForm.mobile" name="mobile" placeholder="手机号码"
                                    :rules="[{ required: true, message: '请填写手机号码' }]" />
                                <van-row>
                                    <van-col span="16">
                                        <van-field v-model="registerForm.code" name="code" placeholder="验证码"
                                            :rules="[{ required: true, message: '请填写验证码' }]" />
                                    </van-col>
                                    <van-col span="8">
                                        <button class="code_btn" @click.stop="sendCode(loginForm.mobile)" v-if="remainSecond <= 0">获取验证码</button>
                                        <button class="code_btn" v-else >{{ remainSecond }}秒后获取</button>
                                    </van-col>
                                </van-row>
                            </van-cell-group>
                            <p class="info">
                                <van-checkbox v-model="registerForm.agree" name="agree" shape="square" icon-size="18rem"
                                    style="margin-right: 5rem;" />
                                我已阅读并同意 <span>《九色文化用户协议》</span>
                            </p>
                            <van-button round block type="primary" native-type="submit">注册</van-button>
                        </van-form>
                    </div>
                    <p style="font-size: 12rem; color: #2786F6;" @click="isRegister = false;">已有账号，直接登录</p>
                </div>
            </div>
        </div>
    </div>

    <van-popup v-model:show="showPicker" destroy-on-close position="bottom">
        <van-picker :columns="enterTypes" :model-value="pickerValue" @confirm="onConfirm"
            @cancel="showPicker = false" />
    </van-popup>
</template>
<script setup>
import { onMounted, reactive, ref, toRaw } from 'vue';
import { http } from '@/request/http';
import { client } from '@/request/oss';
import { sendCode, remainSecond, clearTimer } from '@/utils/codeSender'
import cookie from 'cookie.js';
import { useRoute } from 'vue-router';
import { showNotify } from 'vant';

const AliPay = 50
const WeChat = 31

const enterTypes = ref([])
const loginType = ref(0)
const isRegister = ref(false)
const showPicker = ref(false)
const pickerValue = ref([])
const registerForm = reactive({
    name: '',
    avatar: '',
    password: '',
    mobile: '',
    code: '',
    type: 1,  //1个人  2企业
    enterType: '',
    enterTypeLabel: '',
    socialType: '',
    socialCode: '',
    socialState: '',
    agree: true,
})
const register_step = ref(1)
const loginForm = reactive({
    // username: '',
    password: '',
    mobile: '',
    code: '',
    rememberMe: true
})
const onSubmit = (values) => {
    console.log('submit', values);
};

onMounted(() => {
    http.get('/app-api/system/dict-data/type?type=enter_type').then(res => {
        enterTypes.value = res.map(item => {
            return {
                text: item.label,
                value: item.value,
            }
        })
    })
})

const onConfirm = ({ selectedValues, selectedOptions }) => {
    registerForm.enterType = selectedOptions[0]?.value
    registerForm.enterTypeLabel = selectedOptions[0]?.text
    pickerValue.value = selectedValues
    showPicker.value = false
}

const uploadCover = e => {
    const file = e.target.files[0]
    const extName = file.name.slice(file.name.lastIndexOf('.'))
    client.setBucket('dfsk-3d')
    client.put(`cover/${Date.now() + extName}`, file).then(result => {
        registerForm.avatar = result.url
    })
}
const route = useRoute()
const login = () => {
    http.post(loginType.value == 1 ? '/app-api/member/auth/sms-login': '/app-api/member/auth/login', toRaw(loginForm)).then(res => {
        if (res && res.accessToken) {
            loginHandle(res)
        }else{
            showNotify({
                message: err || '登录失败',
                type: 'danger',
            })
        }
    })
}

const loginThrid = type => {
    http.get('/app-api/member/auth/social-auth-redirect', {
        params: {
            type,  //微信10  支付宝50
            redirectUri: 'http://www.xinghancloud.com/workbench/login'
        }
    }).then(res => {
        if(res){
            location.href = res
            clearTimer()
        }
    }).catch(err => {
        console.log(err);
        showNotify({
            message: err || '登录失败',
            type: 'danger',
        })
    })
}

onMounted(() => {
    // if (cookie.get('accessToken')) {
    //     router.replace({ path: '/workbench' })
    // }

    const {source, auth_code, code, state} = route.query

    if(state){
        const params = {
            state: state
        }
        //微信
        if(code){
            params.code = code
            params.type = WeChat
        }
        //支付宝
        if(auth_code){
            params.code = auth_code
            params.type = AliPay
        }
        http.post('/app-api/member/auth/social-login', params).then(res => {
            loginHandle(res)
        }).catch(err => {
            console.log(err);
            if(err == '用户不存在'){
                showNotify({
                    message: err || '登录失败',
                    type: 'danger',
                })
            }
        })
    }
})

function loginHandle(res){
    if (res.accessToken) {
        //已注册
        cookie.set('accessToken', res.accessToken, { path: '/' })
        cookie.set('tenantId', res.tenantId, { path: '/' })
        const path = route.query.path ? decodeURIComponent(route.query.path) : '/'
        window.location.href = path
    }
}

</script>

<style scoped lang="scss">
.login-container {
    height: 100vh;
    background-color: #000;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .logo {
        height: 150rem;
        margin-bottom: 20rem;
    }

    .content {
        width: 400rem;
        background-color: #fff;
        border-radius: 10px;
        padding: 20px;
    }

    .code_btn {
        margin: 10rem 0;
        height: 32rem;
        border: none;
        width: 100%;
        background-color: #F8F8F8;
        color: #999999;
    }

    .form_container {
        ::v-deep(.van-button) {
            height: 40rem;
            margin: 10rem 0;
            border-radius: 0;
        }

        ::v-deep(.van-cell-group) {
            padding: 0;

            .van-cell {
                padding: 10rem 0;

                .van-field__control {
                    background-color: #F8F8F8 !important;
                    height: 32rem;
                    padding: 0 10rem;
                }
            }

            .van-cell::after {
                display: none;
            }
        }

        .login_form {

            .tabs {
                display: flex;
                justify-content: center;
                align-items: center;
                margin-bottom: 20rem;
            }

            .tabs span {
                font-size: 18rem;
                padding: 10rem 10rem;
                margin: 0 10rem;
                cursor: pointer;
            }

            .tabs span.active {
                color: #2686F6;
                border-bottom: 2px solid #2686F6;
            }

            .register {
                font-size: 14rem;
                color: #2686F6;
            }

            .line {
                width: 100%;
                height: 1px;
                background-color: #CCCCCC;
                margin: 10rem 0;
            }

            .third_login {
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                margin-top: 20rem;

                .icons {
                    margin: 10rem 0;

                    .van-icon {
                        margin: 0 10rem;
                    }
                }
            }
        }

        .register_form {
            .type_select {
                >div {
                    height: 97rem;
                    line-height: 97rem;
                    text-align: center;
                    width: 100%;
                    background-color: #F2F2F2;
                    margin: 20rem 0;
                }

                .active {
                    background-color: #2686F6;
                    color: #fff;
                }
            }

            h5 {
                font-size: 18rem;
                text-align: center;
            }

            .avatar {
                width: 88rem;
                height: 88rem;
                background-color: #F2F2F2;
                border-radius: 50%;
                margin: 20rem auto;
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;
                background-size: 100% 100%;

                input {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;
                    opacity: 0;
                }
            }

            .info {
                font-size: 12rem;
                color: #999999;
                margin-top: 10rem;
                display: flex;
            }

        }
    }
}
</style>